export const principles = [
  {
    title: "Aligned Thought",
    description:
      "Momentum begins when thought, belief, and emotion align with your vision â€” creating a focused energetic stream.",
    color: "#4cc9f0",
  },
  {
    title: "Cognitive Velocity",
    description:
      "Ideas reinforced by clarity and emotional resonance accelerate, gaining speed like a rolling wave of intent.",
    color: "#ffd700",
  },
  {
    title: "Spiritual Surrender",
    description:
      "Letting go of resistance allows momentum to become inevitable â€” the unseen forces begin to conspire in your favor.",
    color: "#ff6b6b",
  },
  {
    title: "Neural Entrainment",
    description:
      "Repeated aligned thoughts condition the subconscious, forming neural circuits that self-reinforce the desired state.",
    color: "#8eecf5",
  },
  {
    title: "Focused Intention",
    description:
      "Clear intention directs mental energy with precision, reducing internal resistance and amplifying momentum.",
    color: "#ffb300",
  },
  {
    title: "Emotional Resonance",
    description:
      "The alignment of emotion with thought strengthens neural pathways, reinforcing the momentum trajectory.",
    color: "#7c4dff",
  },
  {
    title: "Subconscious Conditioning",
    description:
      "Repeated visualization and belief imprint on the subconscious, automating aligned behaviors and responses.",
    color: "#00bfa5",
  },
  {
    title: "Persistence Over Time",
    description:
      "Sustained application of aligned thought, emotion, and belief ensures momentum compounds rather than dissipates.",
    color: "#d50000",
  },
  {
    title: "Adaptive Awareness",
    description:
      "Being conscious of shifts in thought or emotion allows for corrective alignment, maintaining optimal momentum.",
    color: "#2962ff",
  },
  {
    title: "Integration of Action",
    description:
      "Physical action aligned with mental momentum reinforces the force, converting potential into manifested outcomes.",
    color: "#ff4081",
  },
  {
    title: "Energetic Harmony",
    description:
      "When mental, emotional, and physical energies are harmonized, resistance is minimized, and momentum flows effortlessly.",
    color: "#00e676",
  },
  {
    title: "Clarity of Vision",
    description:
      "A vivid and precise mental image of the desired outcome gives direction and focus, amplifying the momentum.",
    color: "#ffc107",
  },
  {
    title: "Reflective Feedback",
    description:
      "Observing results and recalibrating beliefs, emotions, and thoughts ensures continuous alignment and growth.",
    color: "#8d6e63",
  },
  {
    title: "Energetic Discipline",
    description:
      "Maintaining consistent mental and emotional discipline strengthens the force over time, creating unstoppable momentum.",
    color: "#ff6d00",
  },
];
